import type { Interpolation } from "@emotion/react";

import { colors } from "../colors";
import type { ThemeType } from "../theme";
import { stroke } from "../tokens";

export const stylesOutline: Record<string, Interpolation<ThemeType>> = {
  base: {
    outlineColor: colors.transparent,
    outlineStyle: "solid",
    outlineWidth: stroke.none,
    transition: "all 150ms ease-out",
  },
  focus: (theme) => ({
    outlineColor: colors.transparent,
    ":focus": { outlineColor: theme.semanticColors.primary },
    outlineWidth: stroke.none,
    ":hover": { outlineWidth: stroke.heavy },
  }),
  focusControlled: (theme) => ({
    outlineColor: theme.semanticColors.primary,
    outlineWidth: stroke.heavy,
  }),
  hover: (theme) => ({
    outlineColor: colors.transparent,
    outlineWidth: stroke.none,
    ":hover": {
      outlineColor: theme.semanticColors.neutralsLowest,
      outlineWidth: stroke.heavy,
    },
  }),
  hoverControlled: (theme) => ({
    outlineColor: theme.semanticColors.neutralsLowest,
    outlineWidth: stroke.heavy,
  }),
};
